module.exports = __webpack_public_path__ + "static/media/ic_video_off.fe0b4bb3.svg";